var ChatObject = function(__userObject, __inputData) {

  var $this = this;
  var __ID;
  var __restore;
  var __dateCreate;
  var __userIDGirl;
  var __userIDMan;
  var __userIDCreate;
  var __userObjectMan;
  var __userObjectGirl;
  var __messageList = {};
  var __destroy = false;
  var __create = false;
  var __statusID = false;
  var __messageSetEventInput;
  var __messageSetEventOutput;
  var __messageSetEventTimeout = 2000;
  var __eventEmitter = new $helpers$.EventEmitter;

  /**
   *
   * @return {*}
   * @private
   */
  var _emitEvent = function(name, data, data1) {
    return __eventEmitter.emit.apply($this, arguments);
  };

  /**
   *
   * @param data
   * @return {boolean}
   * @private
   */
  var _appendMessage = function(data) {
    if(!$helpers$.isObject(data) ||
      !$helpers$.isInt(data['ID']) ||
      !$helpers$.isInt(data['chatID']) ||
      !$helpers$.isString(data['message']) ||
      !$helpers$.isInt(data['userIDFrom']) ||
      !$helpers$.isInt(data['userIDTo']) ||
      !$helpers$.isInt(data['typeID']) ||
      !$helpers$.isInt(data['attachID']) ||
      !$helpers$.isInt(data['time'])){
      return false;
    }
    if($this.getMessage(data['ID'])){
      return true;
    }
    var replyMessageData = $this.getReplyMessageData(data['message'] || '');
    var messageData = {};
    messageData['ID'] = data['ID'];
    messageData['chatID'] = data['chatID'];
    messageData['message'] = replyMessageData['message'];
    messageData['messageReplyData'] = replyMessageData['messageReplyData'];
    messageData['userIDFrom'] = data['userIDFrom'];
    messageData['userIDTo'] = data['userIDTo'];
    messageData['typeID'] = data['typeID'];
    messageData['attachID'] = data['attachID'];
    messageData['attachInfo'] = data['attachInfo'] || {};
    messageData['my'] = $this.getUserObject().getID() === data['userIDFrom'];
    messageData['time'] = data['time'];
    messageData['like'] = parseInt(data['like'] || 0);
    messageData['userObjectFrom'] = false;
    if(messageData['userIDFrom'] > 0){
      messageData['userObjectFrom'] = $this.getUserObject().getID() === data['userIDFrom'] ? $this.getUserObject() : $this.getUserObjectChat();
    }
    messageData['userObjectTo'] = false;
    if(messageData['userIDTo'] > 0){
      messageData['userObjectTo'] = $this.getUserObject().getID() === data['userIDTo'] ? $this.getUserObject() : $this.getUserObjectChat();
    }
    __messageList[data['ID']] = messageData;
    _emitEvent('newMessage', messageData);
    return true;
  };

  /**
   *
   * @param ID
   * @return {boolean}
   * @private
   */
  var _removeMessage = function(ID){
    var messageData = $this.getMessage(ID);
    if(!messageData){
      return false;
    }
    delete __messageList[ID];
    _emitEvent('removeMessage', messageData);
    return true;
  };

  /**
   *
   * @param data
   * @return {boolean}
   * @private
   */
  var _updateMessage = function(data) {
    data = $helpers$.isObject(data) ? data : {};
    var messageData = $this.getMessage(data['ID']);
    if(!messageData){
      return false;
    }
    __messageList[data['ID']]['message'] = String(data['message'] || '');
    __messageList[data['ID']]['attachID'] = parseInt(data['attachID'] || 0);
    __messageList[data['ID']]['attachInfo'] = $helpers$.isObject(data['attachInfo']) ? data['attachInfo']: {};
    __messageList[data['ID']]['like'] = parseInt(data['like'] || 0);
    _emitEvent('updateMessage', messageData);
    return true;
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.on = function(name, callback) {
    return __eventEmitter.on(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.once = function(name, callback) {
    return __eventEmitter.once(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.off = function(name, callback) {
    return __eventEmitter.off(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.emit = function(name,data, data1, data2, data3, data4) {
    return __eventEmitter.emit(name,data, data1, data2, data3, data4);
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getUserObject = function(){
    return __userObject || false;
  };

  /**
   *
   * @return {*}
   */
  this.getName = function(){
    return this.getUserObject().getID() === this.getUserIDMan() ? this.getUserIDGirl() : this.getUserIDMan();
  };

  /**
   *
   * @return {boolean}
   */
  this.getDestroy = function(){
    return __destroy || false;
  };

  /**
   *
   * @return {boolean}
   */
  this.isDestroy = function(){
    return !!this.getDestroy();
  };

  /**
   *
   * @return {boolean}
   */
  this.isMyChat = function() {
    return this.getUserObject().getID() === this.getUserIDCreate();
  };

  /**
   *
   * @param msg
   * @return {boolean}
   */
  this.destroy = function(msg) {
    if(this.isDestroy()){
      return false;
    }
    __destroy = msg || true;
    __statusID = 0;
    _emitEvent('destroy');
    __eventEmitter.clearAllListerens();
    return true;
  };

  /**
   *
   * @return {*|{}}
   */
  this.getInputData = function() {
    return __inputData || {};
  };

  /**
   *
   * @return {{}}
   */
  this.getMessageList = function(){
    return Object.assign({}, __messageList) || {};
  };

  /**
   *
   * @param ID
   * @return {*|boolean}
   */
  this.getMessage = function(ID) {
    return this.getMessageList()[ID] || false;
  };

  /**
   * messageOriginal
   */
  this.getReplyMessageData = function(messageOriginal){
    messageOriginal = String(messageOriginal || '');
    var message = messageOriginal;
    var replyBBCode = (String(messageOriginal || '').match(/\[reply:[0-9]+\]/ig) || [])[0] || false;
    var replyMessageData = false;
    if(replyBBCode){
      replyMessageData = this.getMessage(parseInt((replyBBCode.match(/[0-9]+/ig) || [])[0] || 0)) || false;
      message = message.replace(replyBBCode, '');
    }
    return {
      'messageOriginal' : messageOriginal,
      'message' : message,
      'messageReplyData' : replyMessageData
    };
  };

  /**
   *
   * @param data
   * @return {boolean}
   */
  this.update = function(data) {
    if(!$helpers$.isObject(data)){
      setTimeout(function() {
        $this.destroy('update');
      }, 20);
      return false;
    }
    data['messageList'] = $helpers$.isObject(data['messageList']) ? data['messageList'] : {};
    __statusID = data['statusID'];
    if(!__create) {
      __ID = data['chatID'];
      __dateCreate = data['dateCreate'];
      __userIDGirl = data['userIDGirl'];
      __userIDMan = data['userIDMan'];
      __userIDCreate = data['userIDCreate'] || 0;
      __userObjectGirl = $this.getUserObject().getID() === $this.getUserIDGirl() ? $this.getUserObject() : $this.getUserObject().createUserOnline(data['userObjectGirl'], true);
      __userObjectMan = $this.getUserObject().getID() === $this.getUserIDMan() ? $this.getUserObject() : $this.getUserObject().createUserOnline(data['userObjectMan'], true);
    }

	// Баг с мерцанием сообщений 01.09.25
    // for(var i in __messageList){
    //     if(!data['messageList'][__messageList[i]['ID']]){
    //       //_removeMessage(__messageList[i]['ID']);
    //     }
    // }
    for(var i in data['messageList']){
      _appendMessage(data['messageList'][i]);
    }

    __inputData = data;
    if(!$this.getID() || !$this.getUserIDGirl() || !$this.getUserIDMan() || !$this.getUserObjectGirl() || !$this.getUserObjectMan() || !$this.getCreateDate()){
      setTimeout(function() {
        $this.destroy('update');
      }, 20);
      return false;
    }
    __eventEmitter.emit('update', $this);
    return true;
  };


  /**
   *
   * @param message
   * @param attachID
   * @return {Promise}
   */
  this.sendMessage = function(message, attachID) {
    var $this = this;
    return new Promise(function(resolve, reject) {
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chat');
        socketData.setAppNameTarget('chat');
        socketData.setUserID($this.getUserObject().getID());
        socketData.setMethod('sendMessage');
        socketData.appendData('chatID', $this.getID() || 0);
        socketData.appendData('message', message || '');
        socketData.appendData('attachID', attachID || 0);
        socketData.once('success', function() {
          resolve(socketData.getResData());
        });
        socketData.once('failed', function(){
          reject(socketData.getResData());
        });
      }catch (e) {
        return reject({'info' : (e.message || 'Unknown error')});
      }
      $this.getUserObject().sendSocketData(socketData)['catch'](function(data){
        reject(data);
      });
    });
  };

  /**
   *
   * @param messageID
   * @param like
   * @returns {*}
   */
  this.messageLike = function (messageID, like){
    return new Promise(function(resolve, reject){
      if(!$this.getMessage(messageID)){
        return reject({'info' : 'NotFound'});
      }
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chat');
        socketData.setAppNameTarget('chat');
        socketData.setUserID($this.getUserObject().getID());
        socketData.setMethod('messageLike');
        socketData.appendData('chatID', $this.getID() || 0);
        socketData.appendData('messageID', messageID || 0);
        socketData.appendData('like', like || 0);

        socketData.once('success', function() {
          resolve(socketData.getResData());
        });
        socketData.once('failed', function(){
          reject(socketData.getResData());
        });
      }catch (e) {
        return reject({'info' : (e.message || 'Unknown error')});
      }
      $this.getUserObject().sendSocketData(socketData)['catch'](function(data){
        reject(data);
      });
    });
  };

  /**
   *
   * @param msgID
   * @return {Promise}
   */
  this.payAttachMsg = function(msgID) {
    return new Promise(function(resolve, reject){
      if(!$this.getMessage(msgID)){
        return reject({'info' : 'NotFound'});
      }
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chat');
        socketData.setAppNameTarget('chat');
        socketData.setUserID($this.getUserObject().getID());
        socketData.setMethod('payAttachMsg');
        socketData.appendData('chatID', $this.getID() || 0);
        socketData.appendData('ID', msgID || 0);
        socketData.once('success', function() {
          resolve(socketData.getResData());
        });
        socketData.once('failed', function(){
          reject(socketData.getResData());
        });
      }catch (e) {
        return reject({'info' : (e.message || 'Unknown error')});
      }
      $this.getUserObject().sendSocketData(socketData)['catch'](function(data){
        reject(data);
      });
    });
  };

  /**
   *
   * @private
   */
  var _clearMessageSetEvent = function() {
    if(__messageSetEventInput){
      clearTimeout(__messageSetEventInput);
    }
    __messageSetEventInput = undefined;
  };

  /**
   *
   * @private
   */
  var _clearMessageSetEventOutput = function() {
    if(__messageSetEventOutput){
      clearTimeout(__messageSetEventOutput);
      __messageSetEventOutput = undefined;
    }
    _emitEvent('messageSetEvent', false);
  };

  /**
   * Event message set
   */
  this.emitMessageSetEvent = function() {
    if(!__messageSetEventInput){
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chat');
        socketData.setAppNameTarget('chat');
        socketData.setDestroyTime(1);
        socketData.setUserID($this.getUserObject().getID());
        socketData.setMethod('messageSetEvent');
        socketData.appendData('chatID', $this.getID() || 0);
        $this.getUserObject().sendSocketData(socketData)['catch'](function(data){});
        __messageSetEventInput = setTimeout(_clearMessageSetEvent, __messageSetEventTimeout);

      }catch (e) {}
    }
  };

  /**
   *
   * @return {Promise}
   */
  this.exit = function() {
    return new Promise(function(resolve, reject) {
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chat');
        socketData.setAppNameTarget('chat');
        socketData.setUserID($this.getUserObject().getID());
        socketData.setMethod('exit');
        socketData.appendData('chatID', $this.getID() || 0);
        $this.getUserObject().sendSocketData(socketData).then(function() {
          resolve();
        })['catch'](function(data){
          reject(data['info'] || '');
        });
      }catch (e) {
        reject(e.message);
      }
    });
  };

  /**
   *
   * @return {*}
   */
  this.getID = function(){
    return __ID;
  };

  /**
   *
   * @return {*}
   */
  this.getCreateDate = function(){
    return __dateCreate;
  };

  /**
   *
   * @return {*}
   */
  this.getUserObjectChat = function(){
    return this.getUserObject().getID() === this.getUserIDMan() ? this.getUserObjectGirl() : this.getUserObjectMan();
  };

  /**
   *
   */
  this.getUserIDGirl = function(){
    return __userIDGirl;
  };

  /**
   *
   */
  this.getUserIDMan = function(){
    return __userIDMan;
  };

  /**
   *
   * @return {*}
   */
  this.getUserIDCreate = function(){
    return __userIDCreate;
  };

  /**
   *
   * @return {*}
   */
  this.getUserObjectGirl = function() {
    return __userObjectGirl;
  };

  /**
   *
   * @return {*}
   */
  this.getUserObjectMan = function(){
    return __userObjectMan;
  };

  /**
   *
   * @return {boolean|number}
   */
  this.getStatusID = function(){
    return __statusID || 0;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isRestore = function () {
    return !!__restore;
  };

  (function(){
    __restore = $helpers$.isObject(__inputData) ? !!__inputData['restore'] : false;
    $this.once('update', function() {
      __create = true;
      __eventEmitter.emit('create', $this);
    });

    $this.update(__inputData);

    $this.on('SocketData|newMessage', function(SocketData) {
      _appendMessage(SocketData.getData());
    });

    $this.on('SocketData|removeMessage', function(SocketData) {
      _removeMessage(SocketData.getData()['ID'] || 0);
    });

    $this.on('SocketData|updateMessage', function(SocketData) {
      _updateMessage(SocketData.getData());
    });

    $this.on('SocketData|destroy', function(SocketData) {
      $this.destroy(SocketData.getData()['destroy'] || 'Error');
    });


    $this.on('SocketData|messageSetEvent', function() {
      if(__messageSetEventOutput){
        clearInterval(__messageSetEventOutput);
        __messageSetEventOutput = undefined;
      }else{
        _emitEvent('messageSetEvent', true);
      }
      __messageSetEventOutput = setTimeout(_clearMessageSetEventOutput, __messageSetEventTimeout+500);
    });
    $this.on('newMessage', function(messageData){
      if(messageData['userIDFrom'] === $this.getUserObject().getID()) _clearMessageSetEvent();
      if(messageData['userIDFrom'] === $this.getUserObjectChat().getID()) _clearMessageSetEventOutput();
    });
  })();

};

/**
 *
 * @param __userObject
 * @param __inputData
 * @constructor
 */
var ChatRequestObject = function(__userObject, __inputData) {

  var $this = this;
  var __restore;
  var __userIDCreate;
  var __userIDTarget;
  var __statusID;
  var __createTime;
  var __destroyTime;
  var __destroyTimeout;
  var __destroy;
  var __message = '';
  var __attachID = 0;

  var __userObjectTarget;
  var __userObjectCreate;

  var __eventEmitter = new $helpers$.EventEmitter;

  /**
   *
   * @return {*}
   * @private
   */
  var _emitEvent = function(name, data, data1) {
    return __eventEmitter.emit.apply($this, arguments);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.on = function(name, callback) {
    return __eventEmitter.on(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.once = function(name, callback) {
    return __eventEmitter.once(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.off = function(name, callback) {
    return __eventEmitter.off(name, callback);
  };


  /**
   *
   * @return {*}
   */
  this.getIDCreate = function(){
    return __userIDCreate;
  };

  /**
   *
   * @return {*}
   */
  this.getIDTarget = function() {
    return __userIDTarget;
  };

  /**
   *
   * @return {number}
   */
  this.getDestroyTimeout = function(){
    return __destroyTimeout;
  };

  /**
   *
   * @returns {*|number}
   */
  this.getCreateTime = function() {
    return __createTime || 0;
  };

  /**
   *
   * @return {*}
   */
  this.getName = function() {
    var userObject = this.getUserObjectRequest();
    if(!userObject) return false;
    return userObject.getID() || false;
  };

  /**
   *
   * @return {*|string}
   */
  this.getMessage = function(){
    return __message || '';
  };

  /**
   *
   * @returns {number}
   */
  this.getAttachID = function(){
    return __attachID || 0;
  };

  /**
   *
   * @return {number}
   */
  this.getStatusID = function(){
    return __statusID;
  };

  /**
   *
   * @return {*|{}}
   */
  this.getInputData = function(){
    return __inputData || {};
  };

  /**
   *
   * @return {*}
   */
  this.getDestroyTime = function(){
    return __destroyTime;
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getDestroyInfo = function(){
    return __destroy || false;
  };

  /**
   *
   */
  this.getDestroy = function() {
    return this.getDestroyInfo();
  };

  this.isDestroy = function() {
    return !!this.getDestroyInfo();
  };

  /**
   *
   * @return {*}
   */
  this.getUserObject = function() {
    return __userObject || false;
  };

  /**
   *
   * @return {boolean}
   */
  this.isMyRequest = function(){
    return this.getUserObject().getID() === this.getIDCreate();
  };

  /**
   *
   * @param msg
   * @return {boolean}
   */
  this.destroy = function(msg) {
    if(this.isDestroy()){
      return false;
    }
    __destroy = msg || true;
    if(this.getStatusID() === SocketDataObject.STATUS_NEW){
      try{
        this.setStatusID(SocketDataObject.STATUS_FAILED);
      }catch (e) {
        console.error(e);
      }
    }
    _emitEvent('destroy');
    __eventEmitter.clearAllListerens();
    return true;
  };

  /**
   *
   * @param statusID
   * @param destroyMsg
   * @returns {boolean}
   */
  this.setStatusID = function(statusID, destroyMsg){
    if(this.isDestroy() || !$helpers$.inArray(statusID, [
      ChatRequestObject.STATUSID_DESTROY,
      ChatRequestObject.STATUSID_CANCEL_CREATE,
      ChatRequestObject.STATUSID_CANCEL_TARGET,
      ChatRequestObject.STATUSID_SUCCESS,
      ChatRequestObject.STATUSID_TIMEOUT,
      ChatRequestObject.STATUSID_DESTROY_CREATE,
      ChatRequestObject.STATUSID_DESTROY_TARGET,
      ChatRequestObject.STATUSID_DESTROY_NO_MONEY])){
      return false;
    }
    __statusID = statusID;
    if(statusID === ChatRequestObject.STATUSID_SUCCESS){
      __eventEmitter.emit('success', this);
    }else if(statusID === ChatRequestObject.STATUSID_CANCEL_CREATE || statusID === ChatRequestObject.STATUSID_CANCEL_TARGET){
      __eventEmitter.emit('cancel', this);
    }else if(statusID === ChatRequestObject.STATUSID_DESTROY_NO_MONEY){
      __eventEmitter.emit('notMoney', this);
    }
    if(statusID !== ChatRequestObject.STATUSID_CREATE && statusID !== ChatRequestObject.STATUSID_SUCCESS){
      __eventEmitter.emit('failed', this);
    }
    __eventEmitter.emit('changeStatusID');
    this.destroy(destroyMsg);
    return true;
  };

  /**
   *
   * @return {Promise}
   */
  this.confirm = function() {
    var $this = this;
    return new Promise(function(resolve, reject){
      if($this.isDestroy()){
        return reject(new Error('Destroy object'));
      }
      var userObject = $this.getUserObject();
      if(!userObject || userObject.isDestroy() || userObject.getID() !== $this.getIDTarget()){
        return reject(new Error('This user not target'));
      }
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chatRequest');
        socketData.setAppNameTarget('chatRequest');
        socketData.setUserID(userObject.getID());
        socketData.setMethod('confirm');
        socketData.appendData('userID', $this.getIDCreate());
        socketData.once('success', function() {
            resolve(socketData.getResData());
        });
        socketData.once('failed', function(){
          reject(socketData.getResData());
        });
      }catch (e) {
        return reject(e.message || 'Unknown error');
      }
      userObject.sendSocketData(socketData)['catch'](function(data){
        reject(data);
      });
    })
  };

  /**
   *
   * @return {Promise}
   */
  this.cancel = function() {
    var $this = this;
    return new Promise(function(resolve, reject){
      if($this.isDestroy()){
        return reject(new Error('Destroy object'));
      }
      var __userObject = $this.getUserObject();
      if(!__userObject || __userObject.isDestroy()){
        return reject(new Error('Destroy user'));
      }
      var reqID = __userObject.getID() === $this.getIDCreate() ? $this.getIDTarget() : $this.getIDCreate();
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('chatRequest');
        socketData.setAppNameTarget('chatRequest');
        socketData.setUserID(__userObject.getID());
        socketData.setMethod('cancel');
        socketData.appendData('userID', reqID);
      }catch (e) {
        return reject(e.message || 'Unknown error');
      }
      __userObject.sendSocketData(socketData).then(function(data){
        resolve(data);
      })['catch'](function(data){
        reject(data);
      });
    })
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getUserObjectRequest = function(){
    return $this.isMyRequest() ? this.getUserObjectTarget() : this.getUserObjectCreate();
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getUserObjectCreate = function(){
    return __userObjectCreate || false;
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getUserObjectTarget = function(){
    return __userObjectTarget || false;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isRestore = function () {
    return !!__restore;
  };

  /**
   * Constructor
   */
  (function(__inputData) {
    __userIDCreate = parseInt(__inputData['userIDCreate']);
    __userIDTarget = parseInt(__inputData['userIDTarget']);
    __statusID = parseInt(__inputData['statusID']);
    __createTime = parseInt(__inputData['createTime']);
    __destroyTime = parseInt(__inputData['destroyTimeout']);
    __destroy = parseInt(__inputData['destroy']);
    __message = __inputData['message'] || '';
    __attachID = __inputData['attachID'] || 0;
    __restore = !!__inputData['restore'];
    __userObjectCreate = $this.isMyRequest() ? $this.getUserObject() : $this.getUserObject().createUserOnline(__inputData['userObjectCreate'], true);
    __userObjectTarget = !$this.isMyRequest() ? $this.getUserObject() : $this.getUserObject().createUserOnline(__inputData['userObjectTarget'], true);
    if(!$this.getUserObjectCreate() || !$this.getUserObjectTarget()){
      $this.destroy('Invalid create userObjectCreate or userObjectTarget',$this.getUserObjectCreate(), $this.getUserObjectTarget());
    }
  })(__inputData);

};

ChatRequestObject.STATUSID_DESTROY = 0;
ChatRequestObject.STATUSID_CREATE = 1;
ChatRequestObject.STATUSID_SUCCESS = 2;
ChatRequestObject.STATUSID_TIMEOUT = 3;
ChatRequestObject.STATUSID_CANCEL_CREATE = 4;
ChatRequestObject.STATUSID_CANCEL_TARGET = 5;
ChatRequestObject.STATUSID_DESTROY_CREATE = 6;
ChatRequestObject.STATUSID_DESTROY_TARGET = 7;
ChatRequestObject.STATUSID_DESTROY_NO_MONEY = 8;


var DESTROY_TIMEOUT = 10000;

var SocketDataObject = function($inputData) {

  var $this = this;
  var __input = false;
  var __destroy = false;
  var __destroyTimeoutObject = false;

  var __ID = false;
  var __userID = false;
  var __statusID = false;
  var __method = false;
  var __appNameCreate = false;
  var __appNameTarget = false;
  var __data = {};
  var __resData = {};
  var __createTime = false;
  var __destroyTime = false;
  var __userObject = false;
  var __eventEmitter = new $helpers$.EventEmitter;

  /**
   *
   * @return {*}
   * @private
   */
  var _emitEvent = function(name, data, data1) {
    return __eventEmitter.emit.apply($this, arguments);
  };


// GETTERS ----------------------------------------------------------------------------------------
  /**
   *
   * @return {boolean}
   */
  this.getID = function() {
    return __ID || false;
  };

  /**
   *
   * @return {boolean}
   */
  this.getUserID = function(){
    return __userID || false;
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getUserObject = function() {
    return __userObject || false;
  };

  /**
   *
   * @return {boolean}
   */
  this.getStatusID = function(){
    return __statusID;
  };

  /**
   *
   * @return {boolean}
   */
  this.getMethod = function(){
    return __method;
  };

  /**
   *
   * @return {boolean}
   */
  this.getAppNameCreate = function() {
    return __appNameCreate;
  };

  /**
   *
   * @return {boolean}
   */
  this.getAppNameTarget = function() {
    return __appNameTarget;
  };

  /**
   *
   * @return {{}}
   */
  this.getData = function(){
    return __data || {};
  };

  /**
   *
   * @param value
   * @return {*}
   */
  this.getDataValue = function(value){
    return this.getData()[value];
  };

  /**
   *
   */
  this.getResData = function(){
    return __resData || {};
  };

  /**
   *
   * @param value
   * @return {*}
   */
  this.getResDataValue = function(value){
    return this.getResData()[value];
  };
  /**
   *
   * @return {boolean}
   */
  this.getCreateTime = function(){
    return __createTime;
  };

  /**
   *
   * @return {boolean}
   */
  this.getDestroyTime = function(){
    return __destroyTime;
  };

  /**
   *
   * @return {boolean}
   */
  this.getDestroy = function(){
    return __destroy || false;
  };

  /**
   *
   *
   * @return {{}}
   */
  this.getDataCreate = function(){
    return {
      'ID': this.getID(),
      'appNameCreate' : this.getAppNameCreate(),
      'appNameTarget' : this.getAppNameTarget(),
      'method' : this.getMethod(),
      'userID' : this.getUserID(),
      'data' : this.getData(),
      'statusID' : this.getStatusID(),
      'createTime' : this.getCreateTime(),
      'destroyTime' : this.getDestroyTime()
    };
  };

  /**
   *
   * @return {boolean}
   */
  this.isDestroy = function(){
    return !!this.getDestroy();
  };

// /GETTERS ----------------------------------------------------------------------------------------

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.on = function(name, callback) {
    return __eventEmitter.on(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.once = function(name, callback) {
    return __eventEmitter.once(name, callback);
  };

  /**
   *
   * @param name
   * @param callback
   * @return {*}
   */
  this.off = function(name, callback) {
    return __eventEmitter.off(name, callback);
  };

  /**
   *
   * @param ID
   */
  this.setID = function(ID){
    if(!$helpers$.isString(ID)){
      throw new Error('Invalid name');
    }
    __ID = ID;
  };

  /**
   *
   * @param userID
   */
  this.setUserID = function(userID) {
    if(!$helpers$.isInt(userID)){
      throw new Error('Invalid userID');
    }
    __userID = userID;
  };

  /**
   *
   * @param statusID
   * @return {boolean}
   */
  this.setStatusID = function(statusID) {
    switch (statusID) {
      case SocketDataObject.STATUS_NEW:
        if(!$helpers$.isInt(statusID)){
          throw new Error('Invalid status: ' + this.getStatusID() + '->' + statusID);
        }
        __statusID = SocketDataObject.STATUS_NEW;
      break;
      case SocketDataObject.STATUS_SUCCESS:
        if(this.getStatusID() !== SocketDataObject.STATUS_NEW){
          throw new Error('Invalid status: ' + this.getStatusID() + '->' + statusID);
        }
        __statusID = SocketDataObject.STATUS_SUCCESS;
      break;
      case SocketDataObject.STATUS_FAILED:
        if(this.getStatusID() !== SocketDataObject.STATUS_NEW){
          throw new Error('Invalid status: ' + this.getStatusID() + '->' + statusID);
        }
        __statusID = SocketDataObject.STATUS_FAILED;
      break;
      case SocketDataObject.STATUS_DESTROY:
        __statusID = SocketDataObject.STATUS_DESTROY;
      break;
    }
    _emitEvent('setStatusID');
    return true;
  };

  /**
   *
   * @param method
   */
  this.setMethod = function(method){
    if(!$helpers$.isString(method)){
      throw new Error('Invalid method');
    }
    __method = method;
  };

  /**
   *
   * @param data
   * @return {boolean}
   */
  this.setStatusSuccess = function(data) {
    if($helpers$.isObject(data)){
      this.setResData(data);
    }
    return this.setStatusID(SocketDataObject.STATUS_SUCCESS);
  };

  /**
   *
   * @param data
   * @return {boolean}
   */
  this.setStatusFailed = function(data) {
    if($helpers$.isObject(data)){
      this.setResData(data);
    }
    return this.setStatusID(SocketDataObject.STATUS_FAILED);
  };

  /**
   *
   * @param appNameCreate
   */
  this.setAppNameCreate = function(appNameCreate) {
    if(!$helpers$.isString(appNameCreate)){
      throw new Error('Invalid appNameCreate');
    }
    __appNameCreate = appNameCreate;
  };

  /**
   *
   * @param appNameTarget
   */
  this.setAppNameTarget = function(appNameTarget) {
    if(!$helpers$.isString(appNameTarget)){
      throw new Error('Invalid appNameTarget');
    }
    __appNameTarget = appNameTarget;
  };

  /**
   *
   * @param key
   * @param value
   * @return {*}
   */
  this.appendData = function(key, value){
    return __data[key] = value;
  };

  /**
   *
   * @param data
   */
  this.setData = function(data) {
    if(!$helpers$.isObject(data)){
      throw new Error('Invalid data');
    }
    __data = data;
  };

  /**
   *
   * @param key
   * @param value
   * @return {*}
   */
  this.appendResData = function(key, value){
    return __resData[key] = value;
  };

  /**
   *
   * @param resData
   */
  this.setResData = function(resData) {
    if(!$helpers$.isObject(resData)){
      throw new Error('Invalid resData');
    }
    __resData = resData;
  };

  /**
   *
   * @param createTime
   */
  this.setCreateTime = function(createTime){
    if(!$helpers$.isInt(createTime)){
      throw new Error('Invalid createTime');
    }
    __createTime = createTime;
  };

  /**
   *
   * @param destroyTime
   */
  this.setDestroyTime = function(destroyTime) {
    if(!$helpers$.isInt(destroyTime) || destroyTime < 0){
      throw new Error('Invalid destroyTimeout');
    }
    __destroyTime = destroyTime;
    var destroyTimeCount = Date.now() - this.getCreateTime() + this.getDestroyTime();
    __destroyTimeoutObject = setTimeout(function() {
      __destroyTimeoutObject = false;
      $this.destroy('timeout');
    }, destroyTimeCount > 1 ? destroyTimeCount : 1);
  };

  /**
   *
   * @param msg
   * @return {boolean}
   */
  this.destroy = function(msg) {
    if(this.isDestroy()){
      return false;
    }
    __destroy = msg || true;
    if(this.getStatusID() === SocketDataObject.STATUS_NEW){
      try{
        this.setStatusID(SocketDataObject.STATUS_FAILED);
      }catch (e) {
        console.error(e);
      }
    }
    _emitEvent('destroy');
    __eventEmitter.clearAllListerens();
    return true;
  };



  /**
   * Constructor
   */
  (function($inputData) {
    if($helpers$.isObject($inputData)){
      __input = true;
      $this.setID($inputData['ID']);
      $this.setUserID($inputData['userID']);
      $this.setStatusID($inputData['statusID']);
      $this.setAppNameCreate($inputData['appNameCreate']);
      $this.setAppNameTarget($inputData['appNameTarget']);
      $this.setMethod($inputData['method']);
      $this.setData($inputData['data']);
      $this.setCreateTime($inputData['createTime']);
      $this.setDestroyTime($inputData['destroyTime']);
    }else{
      $this.setID($helpers$.uuid());
      $this.setCreateTime(Date.now());
      $this.setDestroyTime(DESTROY_TIMEOUT);
    }
    __userObject = $online$.getUserObject($this.getUserID());
    $this.setStatusID(SocketDataObject.STATUS_NEW);

    $this.on('setStatusID', function() {
      if($this.getStatusID() === SocketDataObject.STATUS_SUCCESS){
        _emitEvent('success');
        $this.destroy('statusSuccess');
      }else if($this.getStatusID() === SocketDataObject.STATUS_FAILED){
        _emitEvent('failed');
        $this.destroy('statusFailed');
      }
    });
  })($inputData);

};
SocketDataObject.STATUS_NEW     = 0;
SocketDataObject.STATUS_SUCCESS = 1;
SocketDataObject.STATUS_FAILED  = 2;
SocketDataObject.STATUS_DESTROY = 3;

var customWebSocket = function (url) {
    var INTERVAL_MESSAGE = 1000;
    var $this = this;
    var __ID;
    var __url;
    var __destroy;
    var __urlParse = {};
    var __messageTimeout;
    var __inputMessage = [];
    this.isCustomSocket = true;
    this.wasClean = 0;
    this.readyState = 0;
    this.code = 0;

    var _sendApiMessage = function () {
        var data = __inputMessage;
        __inputMessage = [];
        _sendAPI('/connection/message', data).then(function(data){
            _parseMessages(data);
            _timeout('start');
        })['catch'](function(){
            $this.close('close');
        });
    };

    /**
     *
     * @param type
     * @returns {boolean}
     * @private
     */
    var _timeout = function (type) {
        switch (type) {
            case 'start' :
                if(__messageTimeout){
                    _timeout('stop');
                }
                __messageTimeout = setTimeout(_sendApiMessage,INTERVAL_MESSAGE);
                return true;
            break;
            case 'stop':
                if(__messageTimeout){
                    try{
                        clearTimeout(__messageTimeout);
                    }catch (e) {}
                    __messageTimeout = undefined;
                }
                return true;
            break;
        }
        return false;
    };
    /**
     *
     * @param msgData
     * @returns {boolean}
     * @private
     */
    var _parseMessages = function (msgData) {
      if(typeof msgData !== 'string') return false;
        try{
            msgData = JSON.parse(msgData);
        }catch (e) {
            msgData = [];
        }
      for(var i in msgData){
          if(msgData[i]){
              try {
                  $this.onmessage({'data' : msgData[i]});
              }catch (e) {}
          }
      }
    };

    /**
     *
     * @param method
     * @param data
     * @returns {Promise}
     * @private
     */
    var _sendAPI = function (method, data) {
      return new Promise(function(resolve, reject){
          if(typeof method !== 'string') return reject(new Error('Invalid params method'));
          if(typeof data !== 'object') return reject(new Error('Invalid params data'));
          var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
          var dataRes = {};
              dataRes['socketID'] = $this.getID();
              dataRes['data'] = data || {};
          var urlReq = __url+method;
          if(method === '/connection'){
              urlReq += __urlParse.search;
          }
          xhr.open("POST", urlReq, true);
          xhr.onreadystatechange = function (ev) {
              if(xhr.readyState === 4){
                  if(xhr.status !== 200){
                      return reject(xhr);
                  }
                  resolve(xhr.responseText);
              }
          };
          xhr.send(JSON.stringify(dataRes));
      });
    };

    this.onopen = function () {};
    this.onclose = function () {};
    this.onmessage = function () {};
    this.onerror = function () {};

    /**
     *
     * @returns {*|boolean}
     */
    this.getID = function () {
      return __ID || false;
    };

    /**
     *
     * @param message
     * @returns {boolean}
     */
    this.send = function (message) {
        if(typeof message !== 'string') return false;
        __inputMessage.push(message);
        _sendApiMessage();
    };

    /**
     *
     */
    this.close = function () {
        this.readyState = 0;
        _sendAPI('/connection/close', {}).then(function () {})['catch'](function () {});
        this.onclose($this);
        this.destroy('close');
    };

    /**
     *
     * @param msg
     * @returns {boolean}
     */
    this.destroy = function (msg) {
        if(__destroy){
            return false;
        }
        _sendAPI('/connection/close', {}).then(function () {})['catch'](function () {});
        __destroy = msg || '';
        this.close();
    };

    (function () {
        if(typeof url !== 'string') throw new Error('Unknown websocket Url');
        __urlParse = document.createElement('a');
        __urlParse.href = url;
        __url = (__urlParse.protocol.replace('wss:', 'https:').replace('ws:', 'http:')) + '//' + __urlParse.hostname + (__urlParse.port && __urlParse.port !== 80 && __urlParse.port !== 443 ? ":"+__urlParse.port : '') + __urlParse.pathname;
        _sendAPI('/connection', {}).then(function (dataJSON) {
            var data = {};
            try{
                data = JSON.parse(dataJSON);
            }catch (e) {}
            if(typeof data['socketID'] !== 'string') return $this.destroy();
            $this.readyState = 1;
            __ID = data['socketID'];
            $this.onopen($this);
            _parseMessages(data['data']);
            _sendApiMessage();
        })['catch'](function (xhr) {
            console.error('catch', xhr);
            $this.destroy('Invalid xhr');
        });
        window.onbeforeunload = function(e) {
            _sendAPI('/connection/close', {}).then(function () {})['catch'](function () {});
        };
    })();
};

/**
 *
 * @param url
 * @constructor
 */
var wsObject = function(url) {

  var PING_MESSAGE = '1';
  var $this = this;
  var __socket;
  var __destroy;
  var __pingLast;
  var __closeClean;
  var __closeCode;
  var __connectionError;
  var __eventEmitter = new $helpers$.EventEmitter;


  /**
   *
   * @return {*}
   * @private
   */
  var _emitEvent = function(name, data, data1) {
    return __eventEmitter.emit.apply($this, arguments);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.on = function(name, callback) {
    return __eventEmitter.on(name, callback);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.once = function(name, callback) {
    return __eventEmitter.once(name, callback);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.off = function(name, callback) {
    return __eventEmitter.off(name, callback);
  };


  /**
   *
   * @param msg
   * @return {*}
   */
  this.send = function(msg) {
    try{
      this.getWS().send(msg);
      return true;
    }catch (e) {}
    return false;
  };

  /**
   *
   * @param data
   * @return {*}
   */
  this.sendData = function(data){
    return this.send($helpers$.json_encode(data));
  };

  /**
   *
   * @param msg
   * @return {boolean}
   */
  this.destroy = function(msg) {
    if(this.isDestroy()){
      return false;
    }
    var ws = this.getWS();
    if(ws){
      ws.close();
    }
    __destroy = msg || 'unknown';
    _emitEvent('destroy');
    __eventEmitter.clearAllListerens();
    return true;
  };

  /**
   *
   * @return {wsObject|boolean}
   */
  this.getWS = function() {
    return $helpers$.isObject(__socket) && __socket.readyState === 1 ? __socket : false;
  };

  /**
   *
   * @return {boolean}
   */
  this.isConnect = function() {
    return !!this.getWS();
  };

  /**
   *
   * @return {*}
   */
  this.getDestroy = function() {
    return __destroy;
  };

  /**
   *
   * @return {boolean}
   */
  this.isDestroy = function() {
    return !!this.getDestroy();
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getCloseCode = function() {
    return __closeCode || false;
  };

  /**
   *
   * @return {boolean}
   */
  this.isCloseClean = function() {
    return !!__closeClean;
  };

  /**
   *
   * @return {*}
   */
  this.getConnectionError = function() {
    return __connectionError;
  };

  /**
   *
   */
  (function() {

      if(typeof WebSocket !== 'undefined'){
          __socket = new WebSocket(url);
      }else{
          __socket = new customWebSocket(url);
          console.warn('Websocket not supported! Init CustomWebSocket!');
      }
    __socket.onopen = function(event) {
      _emitEvent('connect', $this);
    };
    __socket.onclose = function(event) {
      __closeClean = __socket.isCustomSocket? !!__socket.wasClean :  !!event.wasClean;
      __closeCode = __socket.isCustomSocket? __socket.code : event.code;
      _emitEvent('disconnect', $this);
    };
    __socket.onmessage = function(event) {
      if (typeof event.data !== 'string') {
        return false;
      }
      var msg = event.data;
      __pingLast = Date.now();
      if (msg === PING_MESSAGE) {
        return __socket.send(PING_MESSAGE);
      }
      try {
        var data = JSON.parse(msg);
        if(typeof data === 'object'){
          _emitEvent('data', data);
        }
      } catch (e) {
      }
    };
    __socket.onerror = function(event) {
      __connectionError = event.message || 'unknown';
      _emitEvent('error');
    };
    __eventEmitter.on('disconnect', function() {
      $this.destroy('disconnect', $this);
    });
    __eventEmitter.on('error', function() {
      $this.destroy('error');
    });
  })();

};


var userObject = function (onlineObject, ID, isMaster) {
  var $this = this;
  var __restore;
  var __create = false;
  var __destroy = false;
  var __eventEmitter = new $helpers$.EventEmitter;
  var __onlineObject = onlineObject;
  var __ID = parseInt(ID);
  var __master = !!isMaster;
  var __domainID = undefined;
  var __name = undefined;
  var __cityID = undefined;
  var __cityName = undefined;
  var __countryID = undefined;
  var __countryName = undefined;
  var __cover = undefined;
  var __createTime = undefined;
  var __userType = undefined;
  var __agencyID = undefined;
  var __agencyType = undefined;
  var __inviz = undefined;
  var __age = 0;
  var __onlineID = 0;
  var __streamID = 0;
  var __streamRC = false;
  var __streamTransport = '';
  var __requestObjectTmpData = {};
  var __chatObjectTmpData = {};
  var __onlineUserObjectTmpData = {};
  var __requestObjectList = {};
  var __userObjectList = {};
  var __onlineUserObjectList = {};
  var __users = {};
  var __chatObjectList = {};
  var __chatObjectListByName = {};
  var __favoriteList = [];
  var __streamPlayList = [];
  var __publicData = {};
  var __privateData = {};
  var __streamSDK;
  var __streamPublishObject;
  var __streamPlayObjectList = {};
  var __customUser;

  /**
   *
   * @return {*}
   * @private
   */
  var _emitEvent = function() {
    return __eventEmitter.emit.apply($this, arguments);
  };

  this.emitEvent = _emitEvent;

  /**
   *
   * @return {EventEmitter}
   */
  this.on = function(name, callback) {
    return __eventEmitter.on(name, callback);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.once = function(name, callback) {
    return __eventEmitter.once(name, callback);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.off = function(name, callback) {
    return __eventEmitter.off(name, callback);
  };

  /**
   *
   * @returns {boolean}
   */
  this.isCustomUser = function() {
    return !!__customUser;
  };

  /**
   *
   * @param action
   * @returns {boolean}
   */
  this.setCustomUser = function(action) {
    return __customUser = !!action;
  };

  /**
   *
   * @param data
   * @param restore
   * @return {*}
   */
  this.update = function(data, restore){
    if(!$helpers$.isObject(data) ||
      !$helpers$.isInt(data['ID']) ||
      !$helpers$.isInt(data['domainID']) ||
      !$helpers$.isInt(data['streamID']) ||
      !$helpers$.isString(data['name']) ||
      !$helpers$.isInt(data['cityID']) ||
      !$helpers$.isString(data['cityName']) ||
      !$helpers$.isInt(data['countryID']) ||
      !$helpers$.isString(data['countryName']) ||
      !$helpers$.isInt(data['userType']) ||
      this.getID() !== data['ID']
    ){
      return false;
    }
    var events = [];
    // Master User
    if(this.isMaster()){
      if(
        !$helpers$.isInt(data['agencyID']) ||
        !$helpers$.isInt(data['agencyType']) ||
        !$helpers$.isObject(data['onlineUserObjectList']) ||
        !$helpers$.isObject(data['chatObjectList']) ||
        !$helpers$.isArray(data['chatRequestObjectList']) ||
        !$helpers$.isArray(data['favoriteList']) ||
        (!$helpers$.isObject(data['inviz']) &&  data['inviz'] !== false)
      ){
        return false;
      }
    }

    __agencyID = data['agencyID'] || 0;
    __agencyType = data['agencyType'] || 0;
    __inviz = data['inviz'] || false;
    __onlineUserObjectTmpData = data['onlineUserObjectList'] || {};
    __requestObjectTmpData = data['chatRequestObjectList'] || [];
    __chatObjectTmpData = data['chatObjectList'] || [];
    __createTime = data['createTime'] || 0;
    __streamPlayList = data['streamPlayList'] || [];

    // Favorite list
    (function(){
      var favoriteList = $helpers$.isArray(data['favoriteList']) ? data['favoriteList'] : __favoriteList;
      if(favoriteList !== __favoriteList){
        var oldFavoriteList = __favoriteList;
        __favoriteList = favoriteList;
        $helpers$.diffObject(favoriteList, oldFavoriteList, function (i, id){
          _emitEvent('favorite', id);
          _emitEvent('favorite|'+id, id);
        });
        oldFavoriteList = null;
      }
      favoriteList = null;
    })();


    // Public Data
    (function (){
      var publicData = typeof data['publicData'] === 'object' ? data['publicData'] : __publicData;
      if(publicData !== __publicData){
        var oldPublicData = __publicData;
        __publicData = publicData;
        $helpers$.diffObject(publicData, oldPublicData, function (key, data, oldData){
          $this.emitEvent('publicData', key, data, oldData);
          $this.emitEvent('publicData|'+key, data, oldData);
        });
        oldPublicData = null;
      }
      publicData = null;
    })();

    // Private Data
    (function (){
      var privateData = typeof data['privateData'] === 'object' ? data['privateData'] : __privateData;
      if(privateData !== __privateData){
        var oldPrivateData = __privateData;
        __privateData = privateData;
        $helpers$.diffObject(privateData, oldPrivateData, function (key, data, oldData){
          $this.emitEvent('privateData', key, data, oldData);
          $this.emitEvent('privateData|'+key, data, oldData);
        });
        oldPrivateData = null;
      }
      privateData = null;
    })();

    if(__onlineID !== data['onlineID']) events.push('updateOnlineID');
    __onlineID = data['onlineID'] || 0;
    if(__streamID !== data['streamID']) events.push('updateStreamID');
    __streamID = data['streamID'];

    if(__streamRC !== !!data['streamRC']) events.push('updateStreamRC');
    __streamRC = !!data['streamRC'];

    if(__streamTransport !== String(data['streamTransport'] || '')) events.push('updateStreamTransport');
    __streamTransport = String(data['streamTransport'] || '');

    if(__domainID !== data['domainID']) events.push('updateDomainID');
    __domainID = data['domainID'];

    if(__name !== data['name']) events.push('updateName');
    __name = data['name'];

    if(__cityID !== data['cityID']) events.push('updateCityID');
    __cityID = data['cityID'];

    if(__age !== data['age']) events.push('updateAge');
    __age = data['age'];

    if(__cityName !== data['cityName']) events.push('updateCityName');
    __cityName = data['cityName'];

    if(__countryID !== data['countryID']) events.push('updateCountryID');
    __countryID = data['countryID'];

    if(__countryName !== data['countryName']) events.push('updateCountryName');
    __countryName = data['countryName'];

    if(__cover !== data['cover']) events.push('updateCover');
    __cover = data['cover'];

    if(__userType !== data['userType']) events.push('updateUserType');
    __userType = data['userType'];

    // // Create event
    // if(!$this.isCreate()){
    //   events.push('create');
    //   __create = true;
    // }
    if(restore){
      __restore = true;
      events.push('restore');
    }
    _emitEvent('update', $this);
    for(var i in events){
      _emitEvent(events[i], $this);
    }
    if(events.indexOf('updateOnlineID') !== -1){
      _emitEvent($this.isOnline() ? 'online' : 'offline', $this);
    }

    return $this;
  };

  /**
   *
   * @return {number}
   */
  this.getID = function() {
    return __ID;
  };

  /**
   *
   * @returns {[]}
   */
  this.getStreamPlayList = function() {
    return __streamPlayList || [];
  };

  /**
   *
   * @return {number}
   */
  this.getUserType = function() {
    return __userType || 0;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isUserTypeMan = function() {
    return this.getUserType() === 1;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isUserTypeGirl = function() {
    return this.getUserType() === 2;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isUserTypeAgency = function() {
    return this.getUserType() === 3;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isUserTypeModerator = function() {
    return this.getUserType() === 4;
  };

  /**
   *
   * @returns {boolean}
   */
  this.isUserTypeAdmin = function() {
    return this.getUserType() === 5;
  };

  /**
   *
   * @return {number}
   */
  this.getAgencyID = function() {
    return __agencyID || 0;
  };

  /**
   *
   * @return {number}
   */
  this.getAdminType = function(){
    return __adminType || 0;
  };

  /**
   *
   * @return {number}
   */
  this.getDomainID = function(){
    return __domainID || 0;
  };

  /**
   *
   * @return {Array}
   */
  this.getFavoriteList = function() {
    return __favoriteList || [];
  };

  /**
   *
   * @returns {*}
   */
  this.getPublicDataList = function (){
    return $helpers$.isObject(__publicData) ? __publicData : {};
  };

  /**
   *
   * @param key
   * @param defaultValue
   * @returns {*}
   */
  this.getPublicData = function (key, defaultValue){
    return this.getPublicDataList()[key] || defaultValue;
  };

  /**
   *
   * @returns {}
   */
  this.getPrivateDataList = function (){
    return $helpers$.isObject(__privateData) ? __privateData : {};
  };

  /**
   *
   * @param key
   * @param defaultValue
   * @returns {*}
   */
  this.getPrivateData = function (key, defaultValue){
    return this.getPrivateDataList()[key] || defaultValue;
  };

  /**
   *
   * @param userID
   * @returns {number}
   */
  this.getCountPromoChat = function (userID){
    var count = 0;
    var promoChat = this.getPrivateData('promoChat', {});
    if(typeof promoChat === 'object' && typeof promoChat[userID] === 'object'){
        count = parseInt(promoChat[userID]['count_left'] || '0');
    }
    return count;
  };

  /**
   *
   * @return {*}
   */
  this.isFavorite = function(ID) {
    return $helpers$.inArray(ID, this.getFavoriteList());
  };

  /**
   *
   * @param ID
   * @return {*|boolean}
   */
  this.getUserObject = function(ID) {
    return __users[ID] || false;
  };

  /**
   *
   * @return {string}
   */
  this.getName = function(){
    return __name || '';
  };

  /**
   *
   * @return {number}
   */
  this.getOnlineID = function(){
    return __onlineID || 0;
  };

  /**
   *
   * @returns {number}
   */
  this.getStatusID = function () {
    return this.getOnlineID();
  };

  /**
   *
   * @return {number}
   */
  this.getAge = function(){
    return __age || 0;
  };

  /**
   *
   * @return {number}
   */
  this.getCityID = function(){
    return __cityID || 0;
  };

  /**
   *
   * @return {string}
   */
  this.getCityName = function(){
    return __cityName || '';
  };

  /**
   *
   * @return {number}
   */
  this.getCountryID = function(){
    return __countryID || 0;
  };

  /**
   *
   * @return {string}
   */
  this.getCountryName = function(){
    return __countryName || '';
  };

  /**
   *
   * @return {bool|array}
   */
  this.getInviz = function(){
    return __inviz || false;
  };

  /**
   *
   * @return {object}
   */
  this.getCover = function(){
    return __cover || '';
  };

  /**
   *
   * @return {undefined}
   */
  this.getCreateTime = function(){
    return __createTime || 0;
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getOnlineObject = function(){
    return __onlineObject || false;
  };

  /**
   *
   * @return {number}
   */
  this.getStreamID = function(){
    return __streamID || 0;
  };

  /**
   *
   * @return {boolean}
   */
  this.isStreamRC = function(){
    return !!__streamRC;
  };

  /**
   *
   * @return {string}
   */
  this.getStreamTransport = function(){
    return __streamTransport || '';
  };

  /**
   *
   * @return {boolean}
   */
  this.isMaster = function(){
    return !!__master;
  };

  /**
   *
   * @return {boolean}
   */
  this.isCreate = function(){
    return !!__create;
  };

  /**
   *
   * @return {boolean}
   */
  this.getDestroy = function() {
    return __destroy;
  };

  /**
   *
   * @return {boolean}
   */
  this.isDestroy = function(){
    return !!this.getDestroy();
  };

  /**
   *
   * @param msg
   */
  this.destroy = function(msg){
    if (this.isDestroy()) {
      return false;
    }
    __destroy = msg || Date.now();
    __onlineID = 0;
    _emitEvent('updateOnlineID', this);
    _emitEvent('update');
    _emitEvent('destroy');
    __eventEmitter.clearAllListerens();
    return true;
  };

  /**
   *
   * @return {boolean}
   */
  this.isOnline = function(){
    return this.getOnlineID() === userObject.ONLINEID_ONLINE;
  };

  /**
   *
   * @return {boolean}
   */
  this.isOffline = function(){
    return this.getOnlineID() === userObject.ONLINEID_OFFLINE;
  };

  /**
   *
   * @param appName
   * @param method
   * @param data
   * @return {Promise}
   */
  this.send = function(appName, method, data) {
    var $this = this;
    return new Promise(function(resolve, reject) {
      $this.getOnlineObject().sendData($this.getID(), appName, method, data).then(function(data){
        resolve(data);
      })['catch'](function(e){
        reject(e);
      });
    });
  };

  this.getStreamSDK = function() {
    return new Promise(function(resolve, reject) {
      if(!$this.isMaster()){
        return reject(new Error('notMaster'));
      }
      if(__streamSDK){
        return resolve(__streamSDK);
      }
      if(!window.xMediaSDK){
        return reject(new Error('xMediaSDKnotFound'));
      }
      try{
        __streamSDK = new window.xMediaSDK({
          'url': $this.getOnlineObject().getStreamServerUrl(),
          'query': {
            'userID': $this.getOnlineObject().getUserID(),
            'sessionID': $this.getOnlineObject().getSessionID()
          },
          'params': {
            'video': true,
            'audio': false
          },
          'messageList': userObject.STREAM_MESSAGE_LIST
        });
        __streamSDK.getMessage = $this.getStreamMessage;
      }catch (e) {
        return reject(e);
      }
      resolve(__streamSDK);
    });
  };

  /**
   *
   * @param ID
   * @return {Promise}
   */
  this.auth = function(ID) {
    return new Promise(function(resolve, reject) {
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('userObject');
        socketData.setAppNameTarget('session');
        socketData.setMethod('auth');
        socketData.appendData('userID', parseInt(ID));
      }catch (e) {
        return reject(e.message || 'Unknown error');
      }
      $this.sendSocketData(socketData).then(function(data){
        resolve(data);
      })['catch'](function(data){
        reject(data);
      });
    });
  };

  /**
   *
   * @return {Promise}
   */
  this.logout = function() {
    return new Promise(function(resolve, reject) {
      try{
        var socketData = new SocketDataObject();
        socketData.setUserID($this.getID());
        socketData.setAppNameCreate('userObject');
        socketData.setAppNameTarget('userObject');
        socketData.setMethod('logout');
      }catch (e) {
        return reject(e.message || 'Unknown error');
      }
      $this.sendSocketData(socketData).then(function(data){
        resolve(data);
      })['catch'](function(data){
        reject(data);
      });
    });
  };

  /**
   *
   * @param userIDTarget
   * @param message
   * @return {Promise}
   */
  this.createRequest = function(userIDTarget, message, attachID) {
      return new Promise(function(resolve, reject){
        try{
          var socketData = new SocketDataObject();
          socketData.setAppNameCreate('chatRequest');
          socketData.setAppNameTarget('chatRequest');
          socketData.setMethod('create');
          socketData.appendData('userID', userIDTarget);
          socketData.appendData('message', $helpers$.isString(message) ? message : '');
          socketData.appendData('attachID', attachID || 0);
        }catch (e) {
          return reject(e.message || 'Unknown error');
        }
        $this.sendSocketData(socketData).then(function(data){
          resolve(data);
        })['catch'](function(data){
          reject(data);
        });
      });
  };

  /**
   *
   * @return {{}}
   */
  this.getRequestObjectList = function(){
    return __requestObjectList || {};
  };

  /**
   *
   * @param ID
   * @return {*}
   */
  this.getRequestObject = function(ID){
    return this.getRequestObjectList()[ID];
  };

  /**
   *
   * @return {{}}
   */
  this.getUserObjectList = function(){
    return __userObjectList || {};
  };

  /**
   *
   * @param userID
   * @return {*|boolean}
   */
  this.getUserObject = function(userID){
    return this.getOnlineUserObjectList()[userID] || false;
  };


  /**
   *
   * @return {{}}
   */
  this.getOnlineUserObjectList = function(){
    return __onlineUserObjectList || {};
  };

  /**
   *
   * @param userID
   * @return {*|boolean}
   */
  this.getOnlineUserObject = function(userID){
    return this.getOnlineUserObjectList()[userID] || false;
  };

  /**
   *
   * @return {{}}
   */
  this.getChatObjectListByName = function(){
    return __chatObjectListByName || {};
  };

  /**
   *
   * @param name
   * @return {*}
   */
  this.getChatObjectByName = function(name){
    return this.getChatObjectListByName()[name];
  };

  /**
   *
   */
  this.getChatObjectList = function() {
    return __chatObjectList;
  };

  /**
   *
   * @param ID
   * @return {*|boolean}
   */
  this.getChatObject = function(ID) {
    return this.getChatObjectList()[ID] || false;
  };

  /**
   *
   * @param SocketDataObject
   * @return {Promise}
   */
  this.sendSocketData = function(SocketDataObject){
    return new Promise(function(resolve, reject) {
      SocketDataObject.setUserID($this.getID());
      $online$.sendSocketData(SocketDataObject).then(function(data) {
        resolve(data);
      })['catch'](function(data){
        reject(data);
      })
    });
  };

  /**
   *
   * @param SocketDataObject
   * @private
   */
  this._inputSocketData_ = function(SocketDataObject){
    _emitEvent('SocketData', SocketDataObject);
    _emitEvent('SocketData' + '|' + SocketDataObject.getAppNameTarget(), SocketDataObject);
    _emitEvent('SocketData' + '|' + SocketDataObject.getAppNameTarget() + '|' + SocketDataObject.getMethod(), SocketDataObject);
  };

  /**
   *
   * @param data
   * @return {*|boolean}
   * @private
   */
  var _createChatRequest = function(data){
    data = $helpers$.isObject(data) ? data : {};
    var reqID = data['userIDCreate'] === $this.getID() ? data['userIDTarget'] : data['userIDCreate'];
    var requestObject = $this.getRequestObject(reqID);
    if(!requestObject){
      try{
        requestObject = new ChatRequestObject($this, data);
        __requestObjectList[reqID] = requestObject;
        requestObject.once('destroy', function(){
          delete __requestObjectList[reqID];
          _emitEvent('chatRequest|destroy', requestObject);
          _emitEvent('chatRequest|destroy|'+reqID, requestObject);
        });
        _emitEvent('chatRequest|create', requestObject);
        _emitEvent('chatRequest|create|'+reqID, requestObject);
      }catch (e) {
        console.error(e);
      }
    }
    return requestObject || false;
  };

  /**
   *
   * @param data
   * @param isCustomUser
   * @returns {userObject|boolean|*}
   * @private
   */
  var _createUserOnline = function(data, isCustomUser){
    data = $helpers$.isObject(data) ? data : {};
    var userObjectSearch = false;
    try{
      userObjectSearch = $this.getOnlineUserObject(data['ID']);
      if(userObjectSearch){
        return userObjectSearch.update(data);
      }
      userObjectSearch = new userObject($this.getOnlineObject(), data['ID']);
      if(isCustomUser){
        userObjectSearch.setCustomUser(isCustomUser);
      }
      userObjectSearch.once('create', function() {
        if($this.getOnlineUserObject(data['ID'])) return $this.getOnlineUserObject(data['ID']);
        __onlineUserObjectList[data['ID']] = userObjectSearch;
        __eventEmitter.emit('userOnline|ID|'+userObjectSearch.getID(), userObjectSearch);
        userObjectSearch.on('update', function(){
          __eventEmitter.emit('userOnline|update', userObjectSearch);
          __eventEmitter.emit('userOnline|update|'+userObjectSearch.getID(), userObjectSearch);
        });
        userObjectSearch.once('destroy', function(){
          delete __onlineUserObjectList[data['ID']];
          __eventEmitter.emit('userOnline|destroy', userObjectSearch);
          __eventEmitter.emit('userOnline|destroy|'+userObjectSearch.getID(), userObjectSearch);
        });
        __eventEmitter.emit('userOnline|create', userObjectSearch, data['restore']);
        __eventEmitter.emit('userOnline|update', userObjectSearch, data['restore']);
        __eventEmitter.emit('userOnline|create|'+userObjectSearch.getID(), userObjectSearch);
        __eventEmitter.emit('userOnline|update|'+userObjectSearch.getID(), userObjectSearch);
      });
      if (!userObjectSearch.update(data)) {
        userObjectSearch.destroy('create');
        return false;
      }
    }catch (e) {
      console.error(e);
      return false;
    }
    return userObjectSearch;
  };

  /**
   *
   * @param data
   * @private
   */
  var _createChatObject = function(data){
    data = $helpers$.isObject(data) ? data : {};
    try{
      var targetID = $this.getUserType() === 1 ? data['userIDGirl'] : data['userIDMan'];
      var chatObject = $this.getChatObjectByName(targetID);
      if(chatObject){
        chatObject.update(data);
      }else{
        chatObject = new ChatObject($this, data);
        __chatObjectList[chatObject.getID()] = chatObject;
        __chatObjectListByName[chatObject.getName()] = chatObject;
        __eventEmitter.emit('chat|create', chatObject);
        __eventEmitter.emit('chat|create|'+chatObject.getName(), chatObject);
        chatObject.on('destroy', function() {
          delete __chatObjectList[chatObject.getID()];
          delete __chatObjectListByName[chatObject.getName()];
          __eventEmitter.emit('chat|destroy', chatObject);
          __eventEmitter.emit('chat|destroy|'+chatObject.getName(), chatObject);
        });
        chatObject.on('update', function() {
          __eventEmitter.emit('chat|update', chatObject);
          __eventEmitter.emit('chat|update|'+chatObject.getName(), chatObject);
        });
      }
      return true;
    }catch (e) {
      console.error(e);
      return false;
    }
  };

  /**
   *
   * @type {_createUserOnline}
   */
  this.createUserOnline = _createUserOnline;

  this.getStreamMessage = function(error) {
    var keyList = $helpers$.isObject(error) ? [error.name, error.message, error.info] : [error];
    for(var i = 0; i < keyList.length; i++){
      if(keyList[i] && userObject.STREAM_MESSAGE_LIST.hasOwnProperty(String(keyList[i]))){
        return userObject.STREAM_MESSAGE_LIST[String(keyList[i])];
      }
    }
    return userObject.STREAM_MESSAGE_LIST['default'];
  };

  this.getStreamPublishObject = function() {
    return __streamPublishObject && !__streamPublishObject.isDestroyed() ? __streamPublishObject : false;
  };

  this.getStreamPlayObject = function(userID) {
    var mediaObject = __streamPlayObjectList[String(userID)];
    return mediaObject && !mediaObject.isDestroyed() ? mediaObject : false;
  };

  this.streamCreateMediaPublish = function(targetUserID, targetEl, options) {
    targetUserID = parseInt(targetUserID) || 0;
    return $this.getStreamSDK().then(function(streamSDK) {
      var mediaObject = $this.getStreamPublishObject();
      if(mediaObject){
        if(mediaObject.getOptions()['custom']['targetUserID'] === targetUserID){
          return mediaObject;
        }
        mediaObject.destroy();
      }
      options = options || {};
      mediaObject = streamSDK.publish(String($this.getID()), {
        'targetEl': targetEl || null,
        'title': options['title'],
        'autoStart': options['autoStart'],
        'custom': function(mediaObject) {
          var custom = typeof options['custom'] === 'function' ? options['custom'](mediaObject) : (options['custom'] || {});
          custom['targetUserID'] = targetUserID;
          return custom;
        }
      });
      __streamPublishObject = mediaObject;
      mediaObject.once('destroy', function() {
        if(__streamPublishObject === mediaObject){
          __streamPublishObject = undefined;
        }
      });
      return mediaObject;
    });
  };

  this.getSnapshot = function() {
    return new Promise(function(resolve, reject) {
      var masterUserObject = $this.getOnlineObject().getMasterUserObject();
      if(!masterUserObject){
        return reject({'info' : 'notMaster'});
      }
      try{
        var socketData = new SocketDataObject();
        socketData.setAppNameCreate('stream');
        socketData.setAppNameTarget('userObject');
        socketData.setMethod('snapshot');
        socketData.appendData('userID', $this.getID());
      }catch (e) {
        return reject({'info' : e.message || 'Unknown error'});
      }
      masterUserObject.sendSocketData(socketData).then(function(data) {
        resolve(data['url']);
      })['catch'](function(data) {
        reject(data);
      });
    });
  };

  this.streamCreateMediaPlay = function(userID, targetEl, options) {
    var streamName = String(parseInt(userID) || 0);
    return $this.getStreamSDK().then(function(streamSDK) {
      var mediaObject = $this.getStreamPlayObject(streamName);
      if(mediaObject){
        if(!mediaObject.isActive()){
          mediaObject.start()['catch'](function() {});
        }
        return mediaObject;
      }
      options = options || {};
      mediaObject = streamSDK.play(streamName, {
        'targetEl': targetEl || null,
        'title': options['title'],
        'custom': options['custom']
      });
      __streamPlayObjectList[streamName] = mediaObject;
      mediaObject.once('destroy', function() {
        if(__streamPlayObjectList[streamName] === mediaObject){
          delete __streamPlayObjectList[streamName];
        }
      });
      return mediaObject;
    });
  };

  /**
   *
   * @param audio_href
   * @param loop
   * @param messageUser
   * @returns {Promise}
   */
  this.playSound = function(audio_href, loop, messageUser) {
    return new Promise(function(resolve, reject) {
      if(!$helpers$.isString(audio_href) || $helpers$.isEmpty(audio_href)){
        return reject(new Error('Audio invalid href'));
      }
      var _sendLog = function(type, message){
        if(!$helpers$.isString(messageUser) || $helpers$.isEmpty(messageUser)){
          return false;
        }
        return $this.sendLogData('audio', [
          type || '',
          message || '',
          messageUser || ''
        ]);
      };
      try{
        var audio = new Audio(audio_href);
        if(loop){
          audio.loop = !!loop;
        }
        var startTime = 0;
        audio.addEventListener('playing', function(e) {
          startTime = Date.now();
          resolve(audio);
          _sendLog('playing');
        });
        audio.addEventListener('pause', function(e) {
          _sendLog('pause', e.message || '', Date.now() - (startTime || Date.now()));
        });
        audio.addEventListener('onerror', function(e) {
          reject(e);
          _sendLog('error',  e.message || '');
        });
        audio.addEventListener('interruptbegin', function(e) {
          reject(new Error('interruptbegin'));
          _sendLog('interruptbegin',  e.message || '');
        });
        var play = audio.play();
        try{
          if(typeof play['catch'] === 'function'){
            play['catch'](function(e) {
              _sendLog('playCatch',  e.message);
              reject(e);
            });
          }
        }catch (e) {
          _sendLog('playCatch',  e.message);
        }
      }catch (e) {
        reject(e);
        _sendLog('errorCatch',  e.message);
      }
    });
  };

  /**
   *
   * @param type
   * @param data
   * @param notInfo
   * @returns {boolean}
   */
  this.sendLogData = function (type, data, notInfo)
  {
    if(!$helpers$.isString(type) || !$helpers$.isArray(data)){
      return false;
    }
    try{
      var socketData = new SocketDataObject();
      socketData.setAppNameCreate('log');
      socketData.setAppNameTarget('log');
      socketData.setDestroyTime(100);
      socketData.setMethod(type);
      for(var i in data){
        socketData.appendData(i, String(data[i]));
      }
      if(!notInfo){
        socketData.appendData('userAgent', String(navigator.userAgent || ''));
        socketData.appendData('location', String(location.href || ''));
      }
      $this.sendSocketData(socketData)['catch'](function(data){});
      return true;
    }catch (e) {
      return false;
    }
  };

  /**
   *
   * @returns {boolean}
   */
  this.isRestore = function () {
    return !!__restore;
  };

  (function(){
      $this.once('update', function() {
          __create = true;
          _emitEvent('create', $this);
      });
      $this.on('update', function() {
          var tmpArray = {
            'userOnline' : Object.keys($this.getOnlineUserObjectList()),
            'request' : Object.keys($this.getRequestObjectList()),
            'chat' : Object.keys($this.getChatObjectList())
          };
          // Online List
          var online = __onlineUserObjectTmpData;
          for(var i in online){
            online[i]['restore'] = true;
            if(_createUserOnline(online[i])){
              tmpArray.userOnline.splice(tmpArray.userOnline.indexOf(i), 1);
            }
          }
          // Request chat
          var chatRequest = __requestObjectTmpData;
          for(var i in chatRequest){
            chatRequest[i]['restore'] = true;
            if(_createChatRequest(chatRequest[i])){
              tmpArray.request.splice(tmpArray.request.indexOf(i), 1);
            }
          }
          // Chat
          var chatList = __chatObjectTmpData;
          for(var i in chatList){
            chatList[i]['restore'] = true;
            if(_createChatObject(chatList[i])){
              tmpArray.chat.splice(tmpArray.chat.indexOf(i), 1);
            }
          }
          // Destroy old userOnline
          for(var i in tmpArray.userOnline){
              var userOnlineObject = $this.getOnlineUserObject(tmpArray.userOnline[i]);
              if(userOnlineObject && !userOnlineObject.isCustomUser()){
                userOnlineObject.destroy('restore_destroy');
              }
          }
          // Destroy old request
          for(var i in tmpArray.request){
            var requestObject = $this.getRequestObject(tmpArray.request[i]);
            if(requestObject){
              requestObject.destroy('restore_destroy');
            }
          }
          // Destroy old chat
          for(var i in tmpArray.chat){
            var chatObject = $this.getChatObject(tmpArray.chat[i]);
            if(chatObject){
              chatObject.destroy('restore_destroy');
            }
          }
      });


    // Create request
    $this.on('SocketData|chat', function(SocketData){
      var chatObject;
      var data = SocketData.getData();

      if(SocketData.getMethod() === 'create'){
        return _createChatObject(SocketData.getData());
      }
      chatObject = $this.getChatObject(data['chatID']);
      if(!chatObject){
        return false;
      }
      chatObject.emit('SocketData', SocketData);
      chatObject.emit('SocketData' + '|' + SocketData.getMethod(), SocketData);
    });

    // Create request
    $this.on('SocketData|chatRequest|create', function(SocketData){
      _createChatRequest(SocketData.getData());
    });
    $this.on('SocketData|usersOnline|append', function(SocketData){
      _createUserOnline(SocketData.getData());
    });
    $this.on('SocketData|usersOnline|update', function(SocketData){
      _createUserOnline(SocketData.getData());
    });
    $this.on('SocketData|transport', function(SocketData){
      _emitEvent('transport', SocketData.getMethod(), SocketData.getData());
      _emitEvent('transport|'+SocketData.getMethod(), SocketData.getData());
    });
    $this.on('SocketData|usersOnline|remove', function(SocketData){
      var userObj = $this.getOnlineUserObject(SocketData.getData()['ID']);
      if(userObj){
        userObj.destroy('offline');
      }
    });

    // Destroy request
    __eventEmitter.on('SocketData|chatRequest|destroy', function(SocketData) {
      var reqID = SocketData.getDataValue('userIDCreate') === $this.getID() ? SocketData.getDataValue('userIDTarget') : SocketData.getDataValue('userIDCreate');
      var reqObject = $this.getRequestObject(reqID);
      if(!reqObject || !reqObject.setStatusID(SocketData.getDataValue('statusID'), SocketData.getDataValue('destroyMsg'))){
        console.error('request not found', reqID, SocketData.getDataValue('statusID'))
      }
    });
    $this.once('create', function() {
      if($this.isUserTypeGirl()){
          $this.on('chatRequest|create', function(requestObject) {
            if(requestObject.isMyRequest()) return;
            $this.playSound('/request.mp3', true, 'Request '+requestObject.getName()).then(function(audioObj) {
              if (requestObject.isDestroy()){
                audioObj.pause();
              }
              requestObject.once('destroy', function() {
                audioObj.pause();
              });
            })['catch'](function(e) {

            });
          });
        $this.on('chat|create', function(chatObject) {
          $this.playSound('/request.mp3', false, 'Chat '+chatObject.getID())['catch'](function(e) {});
        });
      }
    });
    $this.on('favorite', function(data, oldData) {
      $helpers$.diffObject(data, oldData, function (i, id){
        _emitEvent('favorite|update', id);
        _emitEvent('favorite|update|'+id, id);
      });
    });
    $this.on('publicData', function(key, data, oldData) {
      $helpers$.diffObject(data, oldData, function (i, data, oldData){
        _emitEvent('publicData|'+key, i, data, oldData);
      });
    });
    $this.on('privateData', function(key, data, oldData) {
      $helpers$.diffObject(data, oldData, function (i, data, oldData){
        _emitEvent('privateData|'+key, i, data, oldData);
        _emitEvent('privateData|'+key+'|'+i, data, oldData);
      });
    });
  })();
};

userObject.ONLINEID_OFFLINE = 0;
userObject.ONLINEID_ONLINE = 1;
userObject.STREAM_MESSAGE_LIST = {
  'default': 'Something went wrong. Please try again.',
  'PERMISSION_DENIED': 'Access to the camera or microphone is blocked. Allow it in your browser settings and try again.',
  'DEVICE_NOT_FOUND': 'No camera or microphone found. Connect a device and try again.',
  'DEVICE_BUSY': 'The camera or microphone is used by another application. Close it and try again.',
  'CONSTRAINT_NOT_SATISFIED': 'The selected device is not available. Choose another one in the settings.',
  'INVALID_CONSTRAINTS': 'These camera settings are not supported. Choose another device.',
  'NOT_SUPPORTED': 'Your browser does not support video chat. Please update it or use another browser.',
  'INSECURE_CONTEXT': 'Video chat works only over a secure connection.',
  'MEDIA_ERROR': 'Could not start the camera. Please try again.',
  'NO_STREAM': 'There is no video yet.',
  'PLAY_FAILED': 'Could not play the video. Please try again.',
  'AUTOPLAY_BLOCKED': 'Click the player to start the video.',
  'NOT_CONNECTED': 'Could not connect to the video server. Please try again.',
  'SESSION_RESET': 'The connection was reset. Please start the video again.',
  'INVALID_PLAYER': 'Something went wrong. Please reload the page.',
  'NOT_PUBLISH': 'Something went wrong. Please reload the page.',
  'DESTROYED': 'The video was closed.',
  'BAD_REQUEST': 'Something went wrong. Please reload the page and try again.',
  'FORBIDDEN': 'You cannot start this video right now.',
  'MEDIA_NOT_FOUND': 'This video has already ended.',
  'TIMEOUT': 'The server did not respond in time. Please try again.',
  'INTERNAL': 'Something went wrong on the server. Please try again later.',
  'STREAM_NAME_TAKEN': 'Your camera is already on in another window or tab.',
  'STREAM_NOT_FOUND': 'This user is not streaming right now.',
  'STREAM_NAME_INVALID': 'This stream is not available.',
  'STREAM_ENDED': 'The stream has ended.',
  'STREAM_NOT_READY': 'The stream is not ready yet. Please try again in a moment.',
  'CODEC_UNSUPPORTED': 'Your browser does not support this video format. Please try another browser.',
  'SDP_INVALID': 'Your browser could not set up the video connection. Please update it or try another browser.',
  'MEDIA_TERMINATED': 'The video was stopped.',
  'STREAM_STOPPED': 'Your video has been stopped.',
  'CAPACITY_EXHAUSTED': 'The video server is busy. Please try again in a few minutes.',
  'SERVICE_UNAVAILABLE': 'Video chat is temporarily unavailable. Please try again later.',
  'invalidName': 'You can stream only from your own profile.',
  'targetUserOffline': 'Your chat partner is offline.',
  'invalidUserObject': 'You are offline. Please reload the page.',
  'destroyUserObject': 'You are offline. Please reload the page.',
  'invalidPay': 'You do not have enough credits for video chat.',
  'notMaster': 'Something went wrong. Please reload the page.',
  'xMediaSDKnotFound': 'Video chat failed to load. Please reload the page.'
};

var onlineObject = function(config) {

  var $this = this;
  var __connectionTimeout = 2000;
  var __userID = 0;
  var __sessionID = '';
  var __server = '';
  var __streamServer = '';
  var __wsObject;
  var __eventEmitter = new $helpers$.EventEmitter;
  var __connectionTimer = false;
  var __userObjectList = {};
  var __socketDataList = {};


  /**
   *
   * @return {boolean}
   * @private
   */
  var _createConnection = function() {
    if ($this.getWsObject()) {
      return false;
    }
    __wsObject = new wsObject(_getServerUrl());
    __wsObject.on('connect', function() {
      if ($helpers$.isObject(__connectionTimer)) {
        clearTimeout(__connectionTimer);
        __connectionTimer = undefined;
      }
      _emitEvent('connect', this);
    });
    __wsObject.once('destroy', function() {
      __wsObject = undefined;
      _emitEvent('disconnect', this);
      if ($helpers$.isObject(__connectionTimer)) {
        clearTimeout(__connectionTimer);
        __connectionTimer = undefined;
      }
      __connectionTimer = setTimeout(function() {
        _createConnection();
      }, __connectionTimeout);
    });

    __wsObject.on('data', function(data){
      if(!$helpers$.isObject(data) || !$helpers$.isString(data['ID']) || !$helpers$.isInt(data['statusID'])){
        return;
      }
      var socketDataObject;

      if(data['action'] === 'create'){
        try {
          socketDataObject = new SocketDataObject(data);
          socketDataObject.once('destroy', function() {
            delete __socketDataList[socketDataObject.getID()];
          });
          socketDataObject.once('success', function() {
            if(this.getDestroy() === 'timeout'){
              return;
            }
            return $this.sendData({
              'ID': socketDataObject.getID(),
              'statusID': socketDataObject.getStatusID(),
              'resData': socketDataObject.getResData(),
              'action': 'update'
            });
          });
          socketDataObject.once('failed', function() {
            if(this.getDestroy() === 'timeout'){
              return;
            }
            return $this.sendData({
              'ID': socketDataObject.getID(),
              'statusID': socketDataObject.getStatusID(),
              'resData': socketDataObject.getResData(),
              'action': 'update'
            });
          });
          __socketDataList[socketDataObject.getID()] = socketDataObject;
          _emitEvent('SocketData', socketDataObject);
        }catch (e) {
          console.info(e);
        }
      }else if(data['action'] === 'update'){
        try{
          socketDataObject = __socketDataList[data['ID']] || false;
          if(!socketDataObject) return;
          socketDataObject.setResData(data['resData'] || {});
          socketDataObject.setStatusID(data['statusID']);
        }catch (e) {
          console.info(e);
        }
      }

    });
    return true;
  };


  /**
   *
   * @return {*}
   * @private
   */
  var _emitEvent = function() {
    return __eventEmitter.emit.apply($this, arguments);
  };

  /**
   *
   * @returns {string}
   */
  var _getServerUrl = function() {
    return __server + '/?userID=' + $this.getUserID() + '&sessionID=' + $this.getSessionID();
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.on = function(name, callback) {
    return __eventEmitter.on(name, callback);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.once = function(name, callback) {
    return __eventEmitter.once(name, callback);
  };

  /**
   *
   * @return {EventEmitter}
   */
  this.off = function(name, callback) {
    return __eventEmitter.off(name, callback);
  };

  /**
   *
   * @returns {*|number}
   */
  this.getUserID = function() {
    return __userID;
  };

  /**
   *
   * @returns {*|string}
   */
  this.getSessionID = function() {
    return __sessionID;
  };

  /**
   *
   * @return {string}
   */
  this.getStreamServerUrl = function() {
    return __streamServer || '';
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getWsObject = function() {
    return __wsObject || false;
  };

  this.getWsObjectReady = function (ttl){
    return new Promise(function (resolve, reject) {
      ttl = $helpers$.isInt(ttl) ? ttl : 8000;
      var wsObject = $this.getWsObject();
      if(wsObject){
        return resolve(wsObject);
      }
      var timeout = setTimeout(function (){
          reject(new Error('failedConnection'));
      }, ttl);
      $this.on('connection', function (){
        resolve($this.getWsObject());
        try{
          clearInterval(timeout);
        }catch (e){}
      });
    });
  };

  /**
   *
   * @return {*}
   */
  this.isConnect = function() {
    return this.getWsObject() ? this.getWsObject().isConnect() : false;
  };


  /**
   *
   * @return {{}}
   */
  this.getUserObjectList = function() {
    return __userObjectList || {};
  };

  /**
   *
   * @param val
   * @return {*}
   */
  this.getConfigVal = function(val, def) {
    return config[val] || def || undefined;
  };

  /**
   *
   * @param ID
   */
  this.getUserObject = function(ID) {
    return this.getUserObjectList()[ID] || false;
  };

  /**
   *
   * @return {*|boolean}
   */
  this.getMasterUserObject = function(){
    return this.getUserObject(this.getUserID()) || false;
  };

  /**
   *
   * @return {Promise}
   */
  this.getMasterUserObjectReady = function(){
    return new Promise(function(resolve) {
      if($this.getMasterUserObject()){
        return resolve($this.getMasterUserObject());
      }
      $this.on('user|create', function(userObject){
        if(userObject.isMaster()){
          resolve(userObject);
        }
      });
    });
  };

  /**
   *
   * @param SocketDataObject
   * @return {Promise}
   */
  this.sendSocketData = function(SocketDataObject) {
    return new Promise(function(resolve, reject) {
      SocketDataObject.once('destroy', function() {
        delete __socketDataList[SocketDataObject.getID()];
      });
      __socketDataList[SocketDataObject.getID()] = SocketDataObject;
      $this.sendData({
        'ID': SocketDataObject.getID(),
        'appNameCreate' : SocketDataObject.getAppNameCreate(),
        'appNameTarget' : SocketDataObject.getAppNameTarget(),
        'method' : SocketDataObject.getMethod(),
        'userID' : SocketDataObject.getUserID(),
        'data' : SocketDataObject.getData(),
        'statusID' : SocketDataObject.getStatusID(),
        'createTime' : SocketDataObject.getCreateTime(),
        'destroyTime' : SocketDataObject.getDestroyTime(),
        'action' : 'create'
      }).then(function() {
        SocketDataObject.once('success', function() {
          resolve(this.getResData());
        });
        SocketDataObject.once('failed', function() {
          reject(this.getResData());
        });
      })['catch'](function(e){
        try{
          SocketDataObject.setResData({'info' : 'connectionFailed'});
          SocketDataObject.setStatusID(SocketDataObject.STATUS_FAILED);
        }catch (e) {}
        reject({'info' : e.message || 'Sorry there is connection problem'});
      });
    });
  };


  /**
   *
   * @param data
   * @param ttl
   * @return {Promise}
   */
  this.sendData = function(data, ttl){
    return new Promise(function(resolve, reject) {
      if(!$helpers$.isObject(data)){
        return reject('Invalid input data');
      }
      $this.getWsObjectReady(ttl).then(function (wsObject){
        if(wsObject.sendData(data)){
          return resolve();
        }
        reject(new Error('InvalidSend'));
      })['catch'](function (e){
        reject(e);
      });
    });
  };

  /**
   *
   */
  (function() {
    if(!$helpers$.isObject(config)){
      console.error('Invalid config!');
      return false;
    }
    if(!$this.getConfigVal('socketServer')){
      console.error('Invalid socketServer!');
      return false;
    }
    __userID = $this.getConfigVal('userID', 0);
    __sessionID = $this.getConfigVal('sessionID', '');
    __server = $this.getConfigVal('socketServer', '');
    __streamServer = $this.getConfigVal('streamServer', '');


    __eventEmitter.on('disconnect', function(socket) {
      console.warn('WS disconnection, code:', socket.getCloseCode(), '; Next connection : ', __connectionTimeout);
    });
    __eventEmitter.on('SocketData|session|auth', function(SocketDataObject) {
      var User = $this.getUserObject(SocketDataObject.getUserID());
      if (User) {
        if (!User.update(SocketDataObject.getData(), true)) {
          User.destroy('InvalidUpdate');
        }
      } else {
        User = new userObject($this, SocketDataObject.getUserID(), $this.getUserID() === SocketDataObject.getUserID());
        User.once('create', function() {
          __userObjectList[this.getID()] = this;
          this.on('update', function() {
            _emitEvent('user|update', this);
          });
          this.once('destroy', function() {
            delete __userObjectList[this.getID()];
            _emitEvent('user|destroy', this);
          });
          _emitEvent('user|update', this);
          _emitEvent('user|create', this);
          setTimeout(function () {
            _emitEvent('user|auth', User);
          }, 10);

        });
        if (!User.update(SocketDataObject.getData())) {
          User.destroy('create');
          return console.error('Invalid create User');
        }
      }
    });
    __eventEmitter.on('SocketData|user|update', function(SocketDataObject) {
      var User = $this.getUserObject(SocketDataObject.getUserID());
      if(!User){
        return;
      }
      if (!User.update(SocketDataObject.getData())) {
        User.destroy('InvalidUpdate');
      }
    });

    __eventEmitter.on('SocketData|user|destroy', function(SocketDataObject){
      var User = $this.getUserObject(SocketDataObject.getUserID());
      if(!User){
        return;
      }
      User.destroy(SocketDataObject.getData()['info'] || 'destroy');
    });

    __eventEmitter.on('SocketData', function(SocketDataObject) {
      _emitEvent('SocketData' + '|' + SocketDataObject.getAppNameTarget(), SocketDataObject);
      _emitEvent('SocketData' + '|' + SocketDataObject.getAppNameTarget() + '|' + SocketDataObject.getMethod(), SocketDataObject);
      var userObject = $this.getUserObject(SocketDataObject.getUserID());
      if(!userObject || userObject.isDestroy()) return;
      userObject._inputSocketData_(SocketDataObject);
    });
    _createConnection();
  })();
};
